<script lang="ts" setup name="SuccessCard">
import type { RouteLocationRaw } from 'vue-router';

import BaseButton from '~/components/BaseButton.vue';
import Icon from '~/components/Icon.vue';

const {
  title,
  subTitle = '',
  message = '',
  path = null,
  buttonText = 'back',
  variant = 'primary',
} = defineProps<{
  title: string;
  variant?: 'primary' | 'secondary';
  subTitle?: string;
  message?: string;
  path?: RouteLocationRaw;
  buttonText?: string;
}>();
</script>

<template>
  <div
    class="relative flex flex-col items-center overflow-hidden rounded-lg bg-white py-09 text-center shadow"
  >
    <div
      v-if="variant === 'primary'"
      class="absolute left-0 top-0 h-2 w-full bg-green-6"
    />
    <div
      class="my-6 flex h-14 w-14 items-center justify-center rounded-full border-2 border-green-3 bg-green-0 md:h-28 md:w-28"
    >
      <Icon
        icon="ic:baseline-check"
        size="custom"
        class="text-5xl text-green-6 md:text-8xl"
      />
    </div>
    <p class="mx-2 text-2xl font-bold text-primary-8">
      {{ title }}
    </p>
    <p v-if="subTitle" class="mx-2 mt-2 text-lg font-bold text-primary-8">
      {{ subTitle }}
    </p>
    <slot name="message">
      <p v-if="message" class="mx-2 mt-4">
        {{ message }}
      </p>
    </slot>

    <div class="mb-8 mt-4">
      <slot>
        <BaseButton
          v-if="path"
          variant="btn-secondary"
          data-test="success-card-button"
          :to="path"
        >
          {{ buttonText }}
        </BaseButton>
      </slot>
    </div>
  </div>
</template>
